import React from 'react';

const TabControllerContext = React.createContext(null);

export function useTabContext() {
  return React.useContext(TabControllerContext);
}

export function getTabId(context, value) {
  const { idPrefix } = context;
  if (idPrefix === null) {
    return null;
  }
  return `${context.idPrefix}-Tab-${value}`;
}

export function getIds(context, value) {
  const { idPrefix } = context;
  if (idPrefix === null) {
    return null;
  }
  return {
    tabId: `${idPrefix}-Tab-${value}`,
    panelId: `${idPrefix}-Panel-${value}`,
  };
}

export default TabControllerContext;